// Lightbox: fullscreen image or video overlay. Declarative — opens when the
// parent passes an item, closes on backdrop click / Escape / close button.
// Uses framer-motion for a smooth fade + scale, replacing the old imperative
// DOM-morph code.
import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function Lightbox({ item, onClose }) {
  // Escape closes the overlay. Also lock scroll while open.
  useEffect(() => {
    if (!item) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [item, onClose]);

  return (
    <AnimatePresence>
      {item && (
        <motion.div
          className="pd-lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={onClose}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="pd-lightbox__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
          <motion.div
            className="pd-lightbox__stage"
            initial={{ scale: 0.96, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            {item.type === 'image' ? (
              <>
                <img
                  src={item.src}
                  alt={item.caption || ''}
                  className="pd-lightbox__img"
                />
                {item.caption && (
                  <div className="pd-lightbox__caption">{item.caption}</div>
                )}
              </>
            ) : (
              <video
                src={item.src}
                controls
                autoPlay
                className="pd-lightbox__video"
              />
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
